// extracted by mini-css-extract-plugin
export default {"main":"Reports_main__6k3kI"};